const e = {
  name: "NumberSevenCircleFilled",
  dimensions: { width: 40, height: 40 },
  content: `
    <g clip-path="url(#clip0_12_1934)">
    <path d="M20 40.033C31.0457 40.033 40 31.0787 40 20.033C40 8.98726 31.0457 0.032959 20 0.032959C8.9543 0.032959 0 8.98726 0 20.033C0 31.0787 8.9543 40.033 20 40.033Z" fill="currentColor"/>
    <path d="M17.5 15.033H22.5L17.5 25.033" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <defs>
    <clipPath id="clip0_12_1934">
    <rect width="40" height="40" fill="white" transform="translate(0 0.032959)"/>
    </clipPath>
    </defs>
    `
};
export {
  e as NumberSevenCircleFilled
};
